export const QualityApprovalIcon = () => {
  return (
    <svg
    width="25"
    height="25"
    viewBox="12 12 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16773_42049)">
        <path
          d="M26.1111 31.0781C31.1852 31.0781 35.2986 26.9647 35.2986 21.8906C35.2986 16.8165 31.1852 12.7031 26.1111 12.7031C21.037 12.7031 16.9236 16.8165 16.9236 21.8906C16.9236 26.9647 21.037 31.0781 26.1111 31.0781Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M26.1111 28.2656C29.6319 28.2656 32.4861 25.4114 32.4861 21.8906C32.4861 18.3698 29.6319 15.5156 26.1111 15.5156C22.5903 15.5156 19.7361 18.3698 19.7361 21.8906C19.7361 25.4114 22.5903 28.2656 26.1111 28.2656Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M23.0245 21.9946L25.0132 23.9833L28.9907 20.0059M18.6967 27.3167L12.9961 33.0173L14.9849 35.0061L20.6855 29.3054M16.6314 29.382L18.6202 31.3708"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_16773_42049">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
